export enum TableFilterTabKey {
  ALL = 'all',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
  ON_HOLD = 'on_hold',
  ARCHIVED = 'archived',
  SLA_EXCEEDED = 'sla_exceeded',
  APPROVED = 'approved',
  PENDING = 'pending',
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CURRENT = 'current',
  PREVIOUS = 'previous',
  OVERDUE = 'overdue',
  MEMBERS = 'members',
  OWNERS = 'owners',
  SCHEDULED = 'scheduled',
  CANCELLED = 'cancelled',
}
